import React, { Component } from 'react';
import { setCookie } from '../../utils/cookie';
import API from '../../utils/API';
import InputField from '../../components/inputs/inputField';
import loginBG from '../../assets/img/backgrounds/corporate_img.jpg';
import logo from '../../assets/img/logos/simple events logo.png';
import { withRouter } from 'react-router-dom';
import GoogleButton from '../../components/custom/googleButton';
import CheckboxInput from '../../components/inputs/checkboxInput';

class Login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			login: {
				email: '',
				password: '',
				error: '',
				disableSubmit: true,
				emailErrorTrigger: false,
				passwordErrorTrigger: false,
				googleError: "",
				submitError: ""
			},
			register: {
				email: '',
				password: '',
				firstName: '',
				lastName: '',
				acceptedTerms: false,
				disableSubmit: true,
				emailErrorTrigger: false,
				passwordErrorTrigger: false,
				acceptedTermsErrorTrigger: false,
				googleError: "",
				submitError: ""
			},
			activePage: 'login', //ENUM: login, register, forgotPassword, verifyEmail
			pendingVerificationEmail: null,
			pendingAuthData: {
				token: null,
				refreshToken: null,
				organizations: null
			},
			verificationState: {
				loading: false,
				error: '',
				success: false,
				otp: '',
				verifying: false
			},
			waitingForGoogle: false
		};
	}

	handleInputChange = (page, field, value) => {
		this.setState((prevState) => {
			const updatedPageState = { ...prevState[page], [field]: value };

			// Check if all required fields are filled
			const disableSubmit = !updatedPageState.email || !updatedPageState.password || (page === 'register' && (!updatedPageState.firstName || !updatedPageState.lastName || !updatedPageState.acceptedTerms));
			updatedPageState.disableSubmit = disableSubmit;

			return { [page]: updatedPageState };
		});
	};

	handleInputBlur = (page, field, value) => {
		this.setState((prevState) => {
			const updatedPageState = { ...prevState[page] };

			// Validate email and password fields on blur
			if (field === 'email') {
				updatedPageState.emailErrorTrigger = !this.validateEmail(value);
			}
			if (page === 'register' && field === 'password') {
				updatedPageState.passwordErrorTrigger = !this.validatePassword(value).valid;
			}

			return { [page]: updatedPageState };
		});
	};

	validateEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};

	validatePassword = (password) => {
		const requirements = {
			length: password.length >= 10,
			uppercase: /[A-Z]/.test(password),
			lowercase: /[a-z]/.test(password),
			number: /\d/.test(password),
			specialChar: /[@$!%*?&]/.test(password)
		};
		return { requirements, valid: Object.values(requirements).every((val) => val) };
	};

	generatePasswordChecklist = (requirements) => {
		return (
			<ul className="password-checklist">
				<li className={requirements.length ? 'green' : 'red'}>At least 10 characters</li>
				<li className={requirements.uppercase ? 'green' : 'red'}>At least one uppercase letter</li>
				<li className={requirements.lowercase ? 'green' : 'red'}>At least one lowercase letter</li>
				<li className={requirements.number ? 'green' : 'red'}>At least one number</li>
				<li className={requirements.specialChar ? 'green' : 'red'}>At least one special character (@$!%*?&)</li>
			</ul>
		);
	};

	submit = () => {
		const { state } = this.props.location;
		const { email, password } = this.state.login;

		if (!email || !password || this.state.login.emailErrorTrigger) {
			this.setState((prevState) => ({
				login: {
					...prevState.login,
					emailErrorTrigger: !email || prevState.login.emailErrorTrigger,
					error: 'Please provide valid credentials. Ensure your email is correct.'
				}
			}));
			return;
		}

		const data = { emailAddress: email, password };
		API().post(`/auth/login`, data)
			.then((res) => {
				if (!res.data.emailVerified) {
					this.setState({
						activePage: 'verifyEmail',
						pendingVerificationEmail: email,
						pendingAuthData: {
							token: res.data.token,
							refreshToken: res.data.refreshToken,
							organizations: res.data.organizations
						},
						verificationState: {
							loading: false,
							error: '',
							success: false,
							otp: '',
							verifying: false
						}
					});
				} else {

					setCookie('authToken', res.data.token);
					setCookie('refreshToken', res.data.refreshToken);
					const organizationData = res.data.organizations;
					if (!organizationData || organizationData.length === 0) {
						window.location.href = '/onboarding';
					} else {
						localStorage.setItem('defaultOrganization', res.data.organizations[0]._id);
						const targetLocation = state?.from?.pathname || `/${res.data.organizations[0]._id}/events`;
						this.navigateTo(targetLocation);
					}
				}
			})
			.catch((err) => {
				const errorMessage = err.response?.data?.message || err.response?.data?.toString() || 'Login failed';
				this.setState((prevState) => ({
					login: {
						...prevState.login,
						error: errorMessage
					}
				}));
			});
	};

	googleLogin = (authCode) => {
		const { state } = this.props.location;
		const data = { authCode: authCode.code };
		API().post(`/auth/googleLogin`, data)
			.then((res) => {
				setCookie('authToken', res.data.token);
				setCookie('refreshToken', res.data.refreshToken);
				this.setState({ waitingForGoogle: false });
				const organizationData = res.data.organizations;
				if (!organizationData || organizationData.length === 0) {
					window.location.href = '/onboarding';
				} else {
					localStorage.setItem('defaultOrganization', res.data.organizations[0]._id);
					const targetLocation = state?.from?.pathname || `/${res.data.organizations[0]._id}/events`;
					this.navigateTo(targetLocation);
				}
			})
			.catch((err) => {
				this.setState({ waitingForGoogle: false });
				console.log(err);
			});
	}

	googleRegister = (authCode) => {
		const data = { authCode: authCode.code };
		API().post(`/auth/googleRegister`, data)
			.then((res) => {
				setCookie('authToken', res.data.token);
				setCookie('refreshToken', res.data.refreshToken);
				this.setState({ waitingForGoogle: false });
				const organizationData = res.data.organizations;
				console.log(organizationData);
				if (!organizationData || organizationData.length === 0) {
					window.location.href = '/onboarding';
				}
			})
			.catch((err) => {
				console.log(err.response.data);
				let errorMessage = err?.response?.data || 'Google registration failed';
				this.setState({
					waitingForGoogle: false,
					register: {
						...this.state.register,
						googleError: errorMessage
					}
				});
				console.log(err);
			});
	}

	submitRegister = () => {
		const { email, password, firstName, lastName, acceptedTerms } = this.state.register;

		if (!email || !password || !firstName || !lastName || !acceptedTerms || this.state.register.emailErrorTrigger || this.state.register.passwordErrorTrigger) {
			this.setState((prevState) => ({
				register: {
					...prevState.register,
					emailErrorTrigger: !email || prevState.register.emailErrorTrigger,
					passwordErrorTrigger: !password || prevState.register.passwordErrorTrigger,
					acceptedTermsErrorTrigger: !acceptedTerms,
					error: 'All fields are required. Ensure your email is correct and your password meets the requirements.'
				}
			}));
			return;
		}

		const data = { emailAddress: email, password, firstName, lastName };
		API().post(`/auth/register`, data)
			.then((res) => {
				this.setState({
					activePage: 'verifyEmail',
					pendingVerificationEmail: email,
					pendingAuthData: {
						token: res.data.token,
						refreshToken: res.data.refreshToken,
						organizations: res.data.organizations
					},
					verificationState: {
						loading: false,
						error: '',
						success: false,
						otp: '',
						verifying: false
					},
					waitingForGoogle: false
				});
			})
			.catch((err) => {
				const errorMessage = err.response?.data?.message || err.response?.data?.toString() || 'Registration failed';
				this.setState((prevState) => ({
					register: {
						...prevState.register,
						error: errorMessage
					}
				}));
			});
	}

	navigateTo = (targetLocation) => {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.getRegistrations().then((registrations) => {
				if (registrations.length > 0) {
					registrations.forEach((reg) => {
						reg.unregister().then(() => {
							window.open(targetLocation, '_self');
						});
					});
				} else {
					window.open(targetLocation, '_self');
				}
			}).catch(() => {
				window.open(targetLocation, '_self');
			});
		} else {
			window.open(targetLocation, '_self');
		}
	}

	renderLogin = () => {
		const { email, password, emailErrorTrigger, passwordErrorTrigger, disableSubmit, error, googleError } = this.state.login;
		return (
			<>
				<h1 className='mb-30 text-c' style={{ fontWeight: 500, fontSize: 24 }}>Log in</h1>
				<GoogleButton loginCallback={this.googleLogin} onLoginStart={() => this.setState({ waitingForGoogle: true })} onLoginCancel={() => this.setState({ waitingForGoogle: false })} onLoginFailure={() => this.setState({ waitingForGoogle: false })} />
				{googleError && <p className='text-c small mt-5' style={{ color: 'red' }}>{googleError}</p>}

				<div className='mb-20 mt-20 flex aic jcc'>
					<p style={{ fontWeight: 500 }}>or</p>
				</div>
				<InputField
					label={'Email'}
					type={'email'}
					onChange={(e) => this.handleInputChange('login', 'email', e.currentTarget.value)}
					onBlur={(e) => this.handleInputBlur('login', 'email', e.currentTarget.value)}
					value={email}
					errorTrigger={emailErrorTrigger}
					errorMessage={'Invalid email format'}
					placeholder="E.g. john@simple.events"
				/>
				<InputField
					classes="mb-0"
					label={'Password'}
					type={'password'}
					onChange={(e) => this.handleInputChange('login', 'password', e.currentTarget.value)}
					value={password}
					errorTrigger={passwordErrorTrigger}
					errorMessage={'Invalid password'}
					placeholder={'Enter your password'}
				/>
				<p className='flex aic mt-10 small'>
					<a className='ml-a' href="javascript:;" onClick={() => this.setState({ activePage: 'forgotPassword' })} style={{ textDecoration: 'underline' }}>Forgot password?</a>
				</p>
				<button
					onClick={this.submit}
					className={`prim ${disableSubmit ? 'inactive' : ''} w-100 mt-30`}
					disabled={disableSubmit}
				>
					Log in
				</button>
				{error && <p className='text-c small mt-5' style={{ color: 'red' }}>{error}</p>}
				{/* <p className='flex jcc aic text-c mt-20 small'>
					<span className='mr-5'>No account?</span>
					<a href="javascript:;" onClick={() => this.setState({ activePage: 'register' })} style={{ textDecoration: 'underline' }}>Create one</a>
				</p> */}
			</>
		);
	}

	renderRegister = () => {
		const { email, password, firstName, lastName, emailErrorTrigger, passwordErrorTrigger, disableSubmit, acceptedTerms, googleError, error } = this.state.register;
		return (
			<>
				<h1 className='mb-30 text-c' style={{ fontWeight: 500, fontSize: 24 }}>Create your account</h1>
				<GoogleButton loginCallback={this.googleRegister} label={'Sign up with Google'} onLoginStart={() => this.setState({ waitingForGoogle: true })} onLoginCancel={() => this.setState({ waitingForGoogle: false })} onLoginFailure={() => this.setState({ waitingForGoogle: false })} />
				{googleError && <p className='text-c small mt-5' style={{ color: 'red' }}>{googleError}</p>}
				<div className='mb-20 mt-20 flex aic jcc'>
					<p style={{ fontWeight: 500 }}>or</p>
				</div>
				<InputField
					label={'First Name'}
					placeholder="E.g. John"
					onChange={(e) => this.handleInputChange('register', 'firstName', e.currentTarget.value)}
					value={firstName}
				/>
				<InputField
					label={'Last Name'}
					placeholder="E.g. Smith"
					onChange={(e) => this.handleInputChange('register', 'lastName', e.currentTarget.value)}
					value={lastName}
				/>
				<InputField
					label={'Company Email'}
					type={'email'}
					onChange={(e) => this.handleInputChange('register', 'email', e.currentTarget.value)}
					onBlur={(e) => this.handleInputBlur('register', 'email', e.currentTarget.value)}
					value={email}
					errorTrigger={emailErrorTrigger}
					errorMessage={'Invalid email format'}
					placeholder="E.g. john@company.com"
				/>
				<InputField
					classes="mb-20"
					label={'Password'}
					type={'password'}
					onChange={(e) => this.handleInputChange('register', 'password', e.currentTarget.value)}
					onBlur={(e) => this.handleInputBlur('register', 'password', e.currentTarget.value)}
					value={password}
					errorTrigger={passwordErrorTrigger}
					errorMessage={'Invalid password'}
					placeholder={'At least 12 characters'}
					alert={passwordErrorTrigger && this.generatePasswordChecklist(this.validatePassword(password).requirements)}
				/>
				<CheckboxInput
					left
					style={{ width: 'fit-content' }}
					checked={acceptedTerms}
					onClick={() => this.handleInputChange('register', 'acceptedTerms', !acceptedTerms)}
					label={<span>I agree with the <a href="/tos">Terms of Use</a></span>}
				/>
				<button
					onClick={this.submitRegister}
					className={`prim ${disableSubmit ? 'inactive' : ''} w-100 mt-10`}
					disabled={disableSubmit}
				>
					Create account
				</button>
				{error && <p className='text-c small mt-5' style={{ color: 'red' }}>{error}</p>}
				<p className='flex jcc aic text-c mt-20 small'>
					<span className='mr-5'>Already have an account?</span>
					<a href="javascript:;" onClick={() => this.setState({ activePage: 'login' })} style={{ textDecoration: 'underline' }}>Log in</a>
				</p>
			</>
		);
	}

	submitForgotPassword = () => {
		const { email } = this.state.forgotPassword || {};

		if (!email || !this.validateEmail(email)) {
			this.setState((prevState) => ({
				forgotPassword: {
					...prevState.forgotPassword,
					emailErrorTrigger: true,
					error: 'Please provide a valid email address.'
				}
			}));
			return;
		}

		const data = { emailAddress: email };
		API().post(`/auth/cantLogin`, data)
			.then(() => {
				this.setState(prevState => ({
					forgotPassword: {
						...prevState.forgotPassword,
						complete: true,
						emailErrorTrigger: false,
						error: ''
					}
				}));
			})
			.catch((err) => {
				const errorMessage = err.response?.data?.message || err.response?.data?.toString() || 'Failed to send reset email';
				this.setState(prevState => ({
					forgotPassword: {
						...prevState.forgotPassword,
						error: errorMessage,
						emailErrorTrigger: true
					}
				}));
			});
	};

	verifyOTP = () => {
		const { pendingVerificationEmail, verificationState } = this.state;
		const { otp } = verificationState;

		if (!otp || otp.length !== 6) {
			this.setState(prevState => ({
				verificationState: {
					...prevState.verificationState,
					error: 'Please enter a valid 6-digit code'
				}
			}));
			return;
		}

		this.setState(prevState => ({
			verificationState: {
				...prevState.verificationState,
				verifying: true,
				error: ''
			}
		}));

		API().post('/auth/verifyEmail', { email: pendingVerificationEmail, code: otp })
			.then(() => {
				const { token, refreshToken, organizations } = this.state.pendingAuthData;
				setCookie('authToken', token);
				setCookie('refreshToken', refreshToken);

				if (!organizations || organizations.length === 0) {
					window.location.href = '/onboarding';
				} else {
					localStorage.setItem('defaultOrganization', organizations[0]._id);
					this.navigateTo(`/${organizations[0]._id}/events`);
				}
			})
			.catch(err => {
				const errorMessage = err.response?.data?.message || err.response?.data?.toString() || 'Invalid verification code';
				this.setState(prevState => ({
					verificationState: {
						...prevState.verificationState,
						verifying: false,
						error: errorMessage
					}
				}));
			});
	};

	resendVerificationEmail = () => {
		const email = this.state.pendingVerificationEmail;
		if (!email) return;

		this.setState(prevState => ({
			verificationState: {
				...prevState.verificationState,
				loading: true,
				error: ''
			}
		}));

		API().post('/auth/resendVerification', { email })
			.then(() => {
				this.setState(prevState => ({
					verificationState: {
						...prevState.verificationState,
						loading: false,
						success: true,
						error: ''
					}
				}));
			})
			.catch(err => {
				const errorMessage = err.response?.data?.message || err.response?.data?.toString() || 'Failed to resend verification email';
				this.setState(prevState => ({
					verificationState: {
						...prevState.verificationState,
						loading: false,
						error: errorMessage
					}
				}));
			});
	};

	renderForgotPassword = () => {
		const { email, complete, error, emailErrorTrigger } = this.state.forgotPassword || { email: '', complete: false, error: '', emailErrorTrigger: false };

		return (
			<>
				{!complete ? (
					<>
						<h1 className='mb-30 text-c' style={{ fontWeight: 500, fontSize: 24 }}>Password Reset Request</h1>
						<p className='text-c mb-30'>
							Enter your email address below and we will send you a password reset link.
						</p>
						<InputField
							label={'Account Email'}
							type={'email'}
							onChange={(e) => {
								const val = e.currentTarget.value;
								this.setState(prevState => ({
									forgotPassword: {
										...prevState.forgotPassword,
										email: val,
										emailErrorTrigger: false,
										error: ''
									}
								}));
							}}
							value={email}
							errorTrigger={emailErrorTrigger}
							errorMessage={'Invalid email format'}
							placeholder="E.g. john@simple.events"
						/>
						<button
							onClick={this.submitForgotPassword}
							className={`prim ${!email ? 'inactive' : ''} w-100 mt-30`}
							disabled={!email}
						>
							Submit
						</button>
						{error && <p className='text-c small mt-5' style={{ color: 'red' }}>{error}</p>}
						<p className='flex jcc aic text-c mt-20 small'>
							<a href="javascript:;" onClick={() => this.setState({ activePage: 'login' })} style={{ textDecoration: 'underline' }}>Back to login</a>
						</p>
					</>
				) : (
					<>
						<h1 className='mb-30 text-c' style={{ fontWeight: 500, fontSize: 24 }}>Password Reset Link Sent</h1>
						<p className='text-c mb-30'>
							If you have a <b>simple.events</b> account, you will receive a password reset link to your email.
						</p>
						<p className='flex jcc aic text-c mt-20 small'>
							<a href="javascript:;" onClick={() => this.setState({ activePage: 'login' })} style={{ textDecoration: 'underline' }}>Back to login</a>
						</p>
					</>
				)}
			</>
		);
	};

	renderVerifyEmail = () => {
		const { pendingVerificationEmail, verificationState } = this.state;
		const { loading, error, success } = verificationState;

		return (
			<>
				<h1 className='mb-30 text-c' style={{ fontWeight: 500, fontSize: 24 }}>Verify Your Email</h1>
				<p className='text-c mb-30'>
					Please verify your email address to continue. We've sent a verification code to:
					<br />
					<strong>{pendingVerificationEmail}</strong>
				</p>
				<InputField
					label={'Verification Code'}
					type={'text'}
					onChange={(e) => {
						const val = e.currentTarget.value.replace(/[^0-9]/g, '').slice(0, 6);
						this.setState(prevState => ({
							verificationState: {
								...prevState.verificationState,
								otp: val,
								error: ''
							}
						}));
					}}
					value={verificationState.otp}
					placeholder="Enter 6-digit code"
					maxLength={6}
				/>
				<button
					onClick={this.verifyOTP}
					className={`prim ${verificationState.verifying ? 'inactive' : ''} w-100 mt-30`}
					disabled={verificationState.verifying || verificationState.otp.length !== 6}
				>
					{verificationState.verifying ? 'Verifying...' : 'Verify Email'}
				</button>
				<button
					onClick={this.resendVerificationEmail}
					className={`sec ${loading ? 'inactive' : ''} w-100 mt-10`}
					disabled={loading}
				>
					{loading ? 'Sending...' : 'Resend Code'}
				</button>
				{error && <p className='text-c small mt-5' style={{ color: 'red' }}>{error}</p>}
				{success && <p className='text-c small mt-5' style={{ color: 'green' }}>New verification code sent!</p>}
				<p className='flex jcc aic text-c mt-20 small'>
					<a href="javascript:;" onClick={() => this.setState({ activePage: 'login' })} style={{ textDecoration: 'underline' }}>Back to login</a>
				</p>
			</>
		);
	};

	render() {
		const { activePage, waitingForGoogle } = this.state;

		return (
			<div className='w-100 h-100 flex column aic jcc' style={{ background: '#f0f0f0', backgroundImage: `url(${loginBG})`, backgroundSize: 'cover', backgroundPositionX: 'center' }}>
				<div className='systemToolbar flex aic' style={{ position: 'absolute', top: 0, height: 100 }} >
					<div className="flex" >
						<div className="navLogo c-pointer" onClick={() => window.location.href = "/"}>
							<img src={logo} alt="logo" style={{ maxHeight: 'unset', height: 35, filter: 'invert(1)' }} />
						</div>
					</div>
				</div>
				<div className='neuCard w-100' style={{ background: 'white', border: 'none', maxWidth: 430, padding: 30 }}>
					{waitingForGoogle ? (
						<h1 className='mb-30 mt-30 text-c' style={{ fontWeight: 500, fontSize: 24 }}>Waiting...</h1>
					) : activePage === 'login' ? (
						this.renderLogin()
					) : activePage === 'register' ? (
						this.renderRegister()
					) : activePage === 'forgotPassword' ? (
						this.renderForgotPassword()
					) : activePage === 'verifyEmail' ? (
						this.renderVerifyEmail()
					) : null}
				</div>
				{activePage === 'register' && <p className='mt-20 small white text-c' style={{ maxWidth: 450 }}>By clicking "Sign-up with Google" above, you acknowledge that you have read, understood and agreed to simple.events <a href="/tos">Terms of Use</a></p>}
			</div>
		);
	}

	componentDidMount() {
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				const { activePage, verificationState } = this.state;
				if (activePage === 'login') {
					this.submit();
				} else if (activePage === 'register') {
					this.submitRegister();
				} else if (activePage === 'verifyEmail' && verificationState.otp.length === 6) {
					this.verifyOTP();
				}
			}
		});
	}
}

export default withRouter(Login);
